import { SET_NPS_OPEN, SET_NPS_PROCESS_TYPE } from '../actionTypes';

export const setNPSOpen = (isOpen) => ({
  type: SET_NPS_OPEN,
  payload: isOpen,
});

export const setNPSProcessType = (processType) => ({
  type: SET_NPS_PROCESS_TYPE,
  payload: processType,
});
